@if (spinnerPort.visible()) {
  <div
    class="overlay bg-surface flex justify-center items-center h-screen w-screen fixed left-0 top-0 z-50">
    <div class="h-20 w-20 absolute flex justify-center items-center rounded-xl">
      <app-spinner-simple/>
    </div>
  </div>
}
